<template>
  <aside
    class="panel-sidebar hidden lg:flex"
    dusk="main-sidebar"
    :aria-label="__('Sidebar')"
  >
    <div class="panel-sidebar__inner">
      <Link
        :href="$url('/')"
        class="panel-sidebar__brand"
        :aria-label="appName"
      >
        <BrandLogo
          class="panel-sidebar__logo"
          img-class="block h-full w-full object-contain brand-logo__image"
        />
        <span class="panel-sidebar__brand-copy">
          <span class="panel-sidebar__brand-name">{{ appName }}</span>
        </span>
      </Link>

      <MainMenu screen="desktop" />
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'

const appName = computed(() => Nova.config('appName'))
</script>
